// Shadows @zillow/auth-core's ACR_VALUES rather than importing it: the bare entrypoint
// re-exports client-only components that break when evaluated in a server component, and
// deep-importing from auth-core's internal submodule isn't visible to every app's TypeScript
// project graph across the monorepo (see deep-imports.test.ts, which guards this against drift).
export const ACR_VALUES = {
  AAL1: 'urn:zillow:assurance:aal:1',
  AAL2: 'urn:zillow:assurance:aal:2',
} as const;

export type ZillowLoginBaseOptions = {
  /** App name (for analytics) */
  entryPoint: string;

  /**
   * Optional: disable force login to allow a user with an existing session to complete login flow
   * without any interaction. The default behavior to force the user to login with credentials which
   * extends their session.
   *
   * @default false
   * */
  disableForceLogin?: boolean;
};

/**
 * Default options for rental manager login, including custom UI configuration.
 */
export const rentalManagerLoginOptions = { uiConfig: { brand: 'zillow-rentals' } } as const;

/**
 * Options for with AAL2 step-up assurance level, also disables force login to re-use existing sessions
 */
export const rentalManagerStepUpLoginOptions = {
  oauthOptions: { acr_values: ACR_VALUES.AAL2 },
  disableForceLogin: true,
} as const;

/**
 * Builds rentalManagerLoginOptions with acr_values derived from the auth user
 * DTO. When the user needs initial multi-factor authentication, request AAL2
 * on the redirect so the login flow triggers the MFA step-up.
 */
export function rentalManagerLoginOptionsForUser(
  user?: { isInitialMultiFactorAuthenticationRequired?: boolean } | null,
) {
  return {
    ...rentalManagerLoginOptions,
    ...(user?.isInitialMultiFactorAuthenticationRequired ? rentalManagerStepUpLoginOptions : {}),
  };
}
